/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
function Seo({
  isHome,
  description,
  title,
  image,
  pathname,
  twitterUsername,
  author,
  children,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            twitterUsername
            image
            siteUrl
          }
        }
      }
    `
  )
  const defaultTitle = site.siteMetadata?.title
  const siteUrl = site.siteMetadata?.siteUrl
  const defaultImage = site.siteMetadata?.image
  const seo = {
    title: title || defaultTitle,
    description: description || site.siteMetadata.description,
    image: !image ? `${siteUrl}${defaultImage}` : `${siteUrl}${image}`,
    url: `${siteUrl}${pathname || ``}`,
    twitterUsername: twitterUsername || site.siteMetadata?.twitterUsername,
    author: author || site.siteMetadata.author,
  }

  return (
    <>
      <title>{defaultTitle ? `${title} | ${defaultTitle}` : title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="author" content={seo.author} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={seo.image} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:site_name" content="Frontendroom" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:site" content={seo.twitterUsername} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:creator" content={seo.twitterUsername} />
      <meta name="msvalidate.01" content="FAD7932E4488B3773122A2930CA3E0F7" />
      <script type="application/ld+json">
        {isHome
          ? `
          [
           {
            "@context" : "https://schema.org",
            "@type" : "WebSite",
            "name" : "Frontendroom",
            "url" : "https://frontendroom.com/"      
           }, 
           {
            "@context": "http://schema.org",
            "@type": "WebPage",
            "name": "${seo.title}",
            "description": "${seo.description}",
            "publisher": {
                "@type": "ProfilePage",
                "name": "${seo.author}"
            }
          }]
        `
          : `
        { 
          "@context": "https://schema.org", 
          "@type": "BlogPosting",
          "headline": "${seo.title}",
          "image": "${seo.image}",
          "publisher": "Frontendroom",
          "url": "${seo.url}",
          "description": "${seo.description}",
          "author": {
            "@type": "Person",
            "name": "${seo.author}"
          }
        }
      `}
      </script>
      <script
        async
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9666200095847888"
      />
      <script
        type="text/javascript"
        src="https://www.ezojs.com/ezoic/sa.min.js"
        async
      />

      {children}
    </>
  )
}

Seo.defaultProps = {
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default Seo
